export const FETCH_CAMPAIGN_UNSUBSCRIBERS_REQUESTED = "FETCH_CAMPAIGN_UNSUBSCRIBERS_REQUESTED";
export const FETCH_CAMPAIGN_UNSUBSCRIBERS_SUCCESS = "FETCH_CAMPAIGN_UNSUBSCRIBERS_SUCCESS";
export const FETCH_CAMPAIGN_UNSUBSCRIBERS_FAIL = "FETCH_CAMPAIGN_UNSUBSCRIBERS_FAIL";
